// 簽到資料 總簽到
import * as types from '../actionType';

let initState = {
  records: [],
  count: 3,
};

function signInTimeState(state = initState, action) {
  switch (action.type) {
      case types.ALL_ATTENDANCE_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default signInTimeState;